<script>
    import Header from './Header.svelte';
    import {mdiPlus,mdiPencil,mdiDelete,mdiLockReset,mdiFormTextboxPassword} from '@mdi/js';
    import {Button,Checkbox,Modal,Card, Field, Input} from 'svelte-chota';
    import {api} from '../lib/api'
    import {onMount} from 'svelte';
    import {aoviSvelte} from 'aovi-svelte';
    import {generatePassword} from './../lib/tools.js';
    import suser from './../stores/user.js';

    

    let users = [];
    onMount(()=>{
        fetchUsers()
    })

    async function fetchUsers(){
        users = await api.get('/user/list')
    }

    async function deleteUser(uid){
        if(confirm('Are you sure?')){
            await api.delete(`/user/${uid}`);
            users = await api.get('/user/list');
        }
    }

    let passwordModal = false;
    let editModal = false;
    let curUid,curForm;
    let curLoading = false;
    function openPasswordModal(uid){
        curUid = uid;
        curForm = aoviSvelte({
            password: ''
        });
        passwordModal=true;
    }

    async function doPasswordChange(){
        curLoading = true;
        let result = await api.put(`/user/${curUid}/password`,curForm.get());
        result.error ? curForm.load(result.error.aovi) : passwordModal=false;
        curLoading=false;
    }

    function openEditModal(uid,name){
        curUid = uid;
        curForm = aoviSvelte({
            user: name
        });
        editModal=true;
    }

    async function doEdit(){
        curLoading = true;
        let result = await api.put(`/user/${curUid}/user`,curForm.get());
        result.error ? curForm.load(result.error.aovi) : (fetchUsers(),editModal=false);
        curLoading=false;
    }


    async function changeAdmin(e,uid){
        if(e.target.checked){
            await api.put(`/user/${uid}/admin`);
        }else{
            await api.delete(`/user/${uid}/admin`);
        }
        fetchUsers();
    }
</script>

<Header title="Manage users" button="Create user" link="/admin/users/create" icon={mdiPlus}/>
<table class="striped">
    <tr>
        <th>Login</th>
        <th>Admin</th>
        <th></th>
    </tr>
    
{#each users as user}
    <tr>
        <td>{user.user}</td>
        <td><Checkbox checked={!!user.admin} disabled={$suser.user==user.user} on:change={e=>changeAdmin(e,user._id)}/></td>
        <td align="right">
            <Button icon={mdiLockReset} on:click={()=>openPasswordModal(user._id)}/>
            <Button icon={mdiPencil} on:click={()=>openEditModal(user._id,user.user)}/>
            <Button icon={mdiDelete} on:click={()=>deleteUser(user._id)}/>
        </td>
    </tr>
{:else}
    <tr><td colspan=4><p class="text-center text-grey">No users</p></td></tr>
{/each}
</table>

<Modal bind:open={passwordModal}>
    <Card>
        <h4 slot="header">New password</h4>

        <Field error={$curForm.err.password} gapless>
            <Input id="newpass"  bind:value={$curForm.password} />
            <Button icon={mdiFormTextboxPassword} primary on:click={()=>$curForm.password=generatePassword(8)}/>
        </Field>
        
        <div slot="footer" class="is-center">
            <Button clear on:click={()=>passwordModal=false}>Cancel</Button>
            <Button on:click={doPasswordChange} loading={curLoading}>Save</Button>
        </div>
    </Card>
</Modal>

<Modal bind:open={editModal}>
    <Card>
        <h4 slot="header">Edit username</h4>

        <Field error={$curForm.err.user}>
            <Input bind:value={$curForm.user} />
        </Field>
        
        <div slot="footer" class="is-center">
            <Button clear on:click={()=>editModal=false}>Cancel</Button>
            <Button on:click={doEdit} loading={curLoading}>Save</Button>
        </div>
    </Card>
</Modal>